import React from 'react';
import { useFormik } from 'formik';
import { withTranslation } from 'react-i18next';
import { Button, Input } from '../../../../UI/Common';
import {
  MultiPropertiesForm,
  ShapeCommonPropertiesForm,
  validationSchema,
} from './Helpers';
import SquarePropertiesForm from './Helpers/SquarePropertiesForm';
import CirclePropertiesForm from './Helpers/CirclePropertiesForm';
import ChartPropertiesForm from './Helpers/ChartPropertiesForm';

function MapPropertyPanel({ t, shape, onEdit, ...props }) {
  const formik = useFormik({
    enableReinitialize: false,
    initialValues: shape,
    onSubmit: (values) => {
      onEdit(values);
    },
    validationSchema,
  });
  React.useEffect(() => {
    formik.setValues(shape);
  }, [shape]);
  function renderForm() {
    switch (shape.className) {
      case 'Multi':
        return <MultiPropertiesForm {...formik} sensors={props.sensors} />;
      case 'Square':
      case 'SquareShape':
        return <SquarePropertiesForm {...formik} groups={props.groups} />;
      case 'Chart':
        return <ChartPropertiesForm {...formik} sensors={props.sensors} />;
      default:
        return <CirclePropertiesForm {...formik} sensors={props.sensors} />;
    }
  }

  function handleWidth(e) {
    const nWidth = e.target.valueAsNumber;
    if (shape.className === 'Background') {
      const { width, height, ratio } = props.originalDimension;
      const newHeight = (nWidth * (height / ratio)) / (width / ratio);
      formik.setFieldValue('dimension.height', Math.ceil(newHeight));
    }
    formik.setFieldValue('dimension.width', nWidth);
  }
  function handleHeight(e) {
    const nHeight = e.target.valueAsNumber;
    if (shape.className === 'Background') {
      const { width, height, ratio } = props.originalDimension;
      const newWidth = (nHeight * (width / ratio)) / (height / ratio);
      formik.setFieldValue('dimension.width', Math.ceil(newWidth));
    }
    formik.setFieldValue('dimension.height', nHeight);
  }
  React.useEffect(() => {
    formik.handleSubmit();
  }, [formik.values]);
  React.useEffect(() => {
    props.isValidated(formik.errors || {});
  }, [formik.errors]);
  return (
    <div className="map-property-panel">
      <div className="d-flex align-items-center">
        <span className="w-100 text-center">{t('Properties')}</span>
        <Button
          classes="d-flex align-items-center"
          style={{ padding: '0px 2px', height: 30 }}
          onClick={props.onDeselectShape}
        >
          <i className="md-icon mr-0">close</i>
        </Button>
      </div>
      {shape.className === 'Background' ? (
        <div className="d-flex flex-row">
          <Input
            id="dimension.width"
            type="number"
            label="Width"
            onChange={handleWidth}
            onFocus={(e) => e.target.select()}
            value={formik.values.dimension.width}
            invalid={
              formik.touched.dimension && formik.touched.dimension['width']
            }
            error={formik.errors.dimension && formik.errors.dimension['width']}
          />
          <Input
            id="dimension.height"
            type="number"
            label="Height"
            onChange={handleHeight}
            onFocus={(e) => e.target.select()}
            value={formik.values.dimension.height}
            invalid={
              formik.touched.dimension && formik.touched.dimension['height']
            }
            error={formik.errors.dimension && formik.errors.dimension['height']}
          />
        </div>
      ) : (
        <>
          <ShapeCommonPropertiesForm {...formik} />
          {renderForm()}
        </>
      )}
    </div>
  );
}

export default withTranslation('app')(MapPropertyPanel);
